<mat-card>
  <mat-card-header>
    <mat-card-title
      cdkDrag
      cdkDragHandle
      cdkDragRootElement=".cdk-overlay-pane"
    >
      {{ title }}
    </mat-card-title>
  </mat-card-header>

  <!-- Form -->
  <mat-card-content style="margin: 2em 0">
    <google-map
      *ngIf="mapOptions.center"
      width="100%"
      height="400px"
      [options]="mapOptions"
    >
      <map-marker
        [position]="coordenadas"
        [options]="markerOptions"
        (mapDragend)="setLocation($event)"
      >
      </map-marker>
    </google-map>
  </mat-card-content>

  <mat-divider></mat-divider>

  <!-- Botones -->
  <mat-card-actions fxLayoutGap="1em">
    <button
      *ngIf="markerOptions.draggable"
      fxFlex
      mat-raised-button
      color="primary"
      (click)="guardar()"
    >
      Guardar
    </button>
    <button mat-raised-button fxFlex type="button" (click)="close()">
      Volver
    </button>
  </mat-card-actions>

  <!-- Progress Bar  -->
  <!-- <mat-card-footer>
      <mat-progress-bar
        [mode]="loading ? 'indeterminate' : 'determinate'"
      ></mat-progress-bar>
    </mat-card-footer> -->
</mat-card>
